import React from "react";
import { Building2 } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { resolveAvatarUrl } from "@/lib/avatarApi";
import { cn } from "@/lib/utils";

function orgInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

/**
 * Renders an organization logo from `avatar_url` with initials/building fallback.
 */
export default function OrganizationAvatar({
  org,
  name,
  avatarUrl,
  className,
  fallbackClassName,
}) {
  const displayName = name || org?.name || "";
  const src = resolveAvatarUrl(avatarUrl ?? org?.avatar_url);
  const initials = orgInitials(displayName);

  return (
    <Avatar className={cn(className)}>
      {src ? <AvatarImage src={src} alt={displayName || "Organization"} /> : null}
      <AvatarFallback className={cn(fallbackClassName)}>
        {initials || <Building2 className="h-4 w-4" />}
      </AvatarFallback>
    </Avatar>
  );
}
